export default __webpack_public_path__ + "8bf1215704784b156458c0d0a9702cab.png";